export const clientesTable = () => [
  { label: "Nombre", key: "nombre" },
  { label: "RFC", key: "rfc" },
  { label: "Notas", key: "notas" },
];
